// 表格列配置
export const tableColumnConfigs = {
    // 索引列
    index: {
        type: 'index',
        label: '#',
        width: '50',
        key: 'index',
        slot: true
    },

    // 权重列
    number: {
        type: 'number',
        label: '权重',
        prop: 'number',
        key: 'number',
        width: '100',
    },

    // 标题列
    title: {
        type: 'text',
        label: '标题',
        prop: 'title',
        key: 'title',
    },

    // 展示位置列
    location: {
        type: 'custom',
        label: '展示位置',
        prop: 'class_id',
        key: 'class_id',
        formatter: 'matchClassName',
    },

    // 开始展示时间
    startAt: {
        type: 'time',
        label: '开始展示时间',
        prop: 'start_at',
        formatter: 'formatDate',
        sortable: "custom",
    },

    // 结束展示时间
    endAt: {
        type: 'time',
        label: '结束展示时间',
        prop: 'end_at',
        formatter: 'formatDate',
        sortable: "custom",
    },

    // 最后展示页面
    lastPage: {
        type: 'text',
        label: '最后展示页面',
        prop: 'last_page',
        key: 'last_page',
    },

    // 状态标签列
    status: {
        type: 'tag',
        label: '状态',
        width: '200',
        key: 'status',
    },

    // 发布状态列
    publishStatus: {
        type: 'custom',
        label: '发布状态',
        prop: 'publish_status',
        key: 'publish_status',
        formatter: 'getPublishStatusContent',
        styleFormatter: 'getPublishStatusStyle'
    },

    // 基础按钮
    baseActions: {
        type: 'actions',
        label: '操作',
        key: 'actions-base',
        fixed: 'right',
        actions: [{
            text: '编辑',
            color: '#03aef9',
            events: [{
                type: 'click',
                function: 'editModel',
            }],
        }, {
            text: '移除',
            color: '#f03c69',
            events: [{
                type: 'click',
                function: 'removeModel',
            }],
        },
        ]
    },

    // 标题列
    name: {
        type: 'text',
        label: '标题',
        prop: 'name',
        key: 'name',
    },

    // 别名列
    alias: {
        type: 'text',
        label: '别名',
        prop: 'alias',
        key: 'alias',
    },

    // 描述列
    info: {
        type: 'text',
        label: '描述',
        prop: 'info',
        key: 'info',
    },

    // 宽高比列
    aspect_ratio_key: {
        type: 'text',
        label: '宽高比',
        prop: 'aspect_ratio_key',
        key: 'aspect_ratio_key',
    },
     // 宽列
     width: {
        type: 'text',
        label: '宽',
        prop: 'width',
        key: 'width',
    },
      // 高列
      height: {
        type: 'text',
        label: '高',
        prop: 'height',
        key: 'height',
    },
       // 平台列
       platform: {
        type: 'text',
        label: '平台',
        prop: 'platform',
        key: 'platform',
    },
};
